module.exports = __webpack_public_path__ + "static/media/2.ddffca29.jpg";